var primaryColors = [
    {
        id: 'white',
        name: 'White'
    },
    {
        id: 'black',
        name: 'Black'
    },
    {
        id: 'gray',
        name: 'Gray'
    },
    {
        id: 'red',
        name: 'Red'
    },
    {
        id: 'brown',
        name: 'Brown'
    },
    {
        id: 'yellow',
        name: 'Yellow'
    },
    {
        id: 'green',
        name: 'Green'
    },
    {
        id: 'blue',
        name: 'Blue'
    },
    {
        id: 'purple',
        name: 'Purple'
    },
    {
        id: 'pink',
        name: 'Pink'
    }
];

var projectColors = [
    {
        id: 'white',
        name: 'White',
        hex: 'ffffff'
    },
    {
        id: 'black',
        name: 'Black',
        hex: '0e0e0e'
    },
    {
        id: 'light-gray',
        name: 'Light Gray',
        hex: 'dedede'
    },
    {
        id: 'gray',
        name: 'Gray',
        hex: 'afafaf'
    },
    {
        id: 'dark-gray',
        name: 'Dark Gray',
        hex: '767676'
    },
    {
        id: 'light-red',
        name: 'Light Red',
        hex: 'f29189'
    },
    {
        id: 'red',
        name: 'Red',
        hex: 'b21205'
    },
    {
        id: 'dark-red',
        name: 'Dark Red',
        hex: '920b00'
    },
    {
        id: 'light-brown',
        name: 'Light Brown',
        hex: '966148'
    },
    {
        id: 'brown',
        name: 'Brown',
        hex: '966148'
    },
    {
        id: 'dark-brown',
        name: 'Dark Brown',
        hex: '71442e'
    },
    {
        id: 'light-yellow',
        name: 'Light Yellow',
        hex: 'f9eb9b'
    },
    {
        id: 'yellow',
        name: 'Yellow',
        hex: 'e1cd59'
    },
    {
        id: 'dark-yellow',
        name: 'Dark Yellow',
        hex: 'b2a13b'
    },
    {
        id: 'light-green',
        name: 'Light Green',
        hex: 'dde2a0'
    },
    {
        id: 'green',
        name: 'Green',
        hex: '93975d'
    },
    {
        id: 'dark-green',
        name: 'Dark Green',
        hex: '6b702f'
    },
    {
        id: 'light-blue',
        name: 'Light Blue',
        hex: 'a4d7ea'
    },
    {
        id: 'blue',
        name: 'Blue',
        hex: '5eadcb'
    },
    {
        id: 'dark-blue',
        name: 'Dark Blue',
        hex: '2e7590'
    },
    {
        id: 'light-purple',
        name: 'Light Purple',
        hex: 'dad8ef'
    },
    {
        id: 'purple',
        name: 'Purple',
        hex: 'b0adcb'
    },
    {
        id: 'dark-purple',
        name: 'Dark Purple',
        hex: '5e5a80'
    },
    {
        id: 'light-pink',
        name: 'Light Pink',
        hex: 'e4c9e3'
    },
    {
        id: 'pink',
        name: 'Pink',
        hex: 'cd80ca'
    }
];

exports.primaryColors = primaryColors;
exports.projectColors = projectColors;

